export const STEPS_ENUM = {
    INTERESTS_SELECTOR: 1,
}

export const INTERESTS_STEP_PARENT_TAGS = {
    MARKETING_CAMPAIGNS: 'marketing_campaigns',
    INTERACTIVE_CONTENT_FOR_WEB_AND_MOBILE: 'interactive_content_for_web_and_mobile',
    EVENT_PRESENTATIONS_AND_TOUCHSCREEN_GAMES: 'event_presentations_and_touchscreen_games',
    EMPLOYEE_ENGAGEMENT: 'employee_engagement',
}
export const INTERESTS_STEP_PARENT_TAGS_NAMES = Object.values(INTERESTS_STEP_PARENT_TAGS)
